module.exports = __webpack_public_path__ + "img/p3-p1-chuanjia.bd1cb1db.png";